<div class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header border-0">
                <div class="d-flex align-items-center gap-2">
                    <a class="text-decoration-none text-primary" href="javascript:void(0)" (click)="closeModal()">
                        <i class="fa-solid fa-arrow-left"></i>
                        @if(showTitle){
                        <span class="ms-2">Mis Servicios</span>
                        }
                    </a>
                </div>
                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle"
                        style="width: 48px; height: 48px;">
                        <i class="fa-solid fa-bag-shopping text-success fs-5"></i>
                    </div>

                    <div>
                        <h5 class="modal-title mb-1 fw-semibold">
                            {{mode === 'create' ? 'Crear nuevo' : mode === 'edit' ? 'Editar' : 'Detalle'}} producto o
                            servicio
                        </h5>
                        @if (mode !== 'view') {
                        <small class="text-muted">
                            Completa los siguientes pasos para configurar tu oferta.
                        </small>
                        } @else {
                        <small class="text-muted">
                            Vista de solo lectura de la oferta actual.
                        </small>
                        }
                    </div>
                </div>

                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>

            <div class="modal-body pt-3">
                <div class="mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="badge bg-primary text-uppercase fw-medium">
                            PASO {{ step() }} DE {{ totalSteps }}
                        </span>
                        <span class="badge bg-primary fw-medium">{{ progressPercentage() }}%</span>
                    </div>

                    <div class="progress mb-3" style="height: 8px;">
                        <div class="progress-bar bg-primary" [style.width.%]="progressPercentage()" role="progressbar">
                        </div>
                    </div>

                    <div class="row text-center small">
                        <div class="col" [class]="getStepClass(1)" *ngFor="let stepName of stepNames; let i = index">
                            {{ stepName }}
                        </div>
                    </div>
                </div>

                <div class="step-content">
                    @switch (step()) {
                    @case (1) {
                    <app-basic-info-step [formData]="wizardData().basicInfo" [isReadonly]=" mode === 'view'"
                        (dataChange)="updateWizardData('basicInfo', $event)">
                    </app-basic-info-step>
                    }
                    @case (2) {
                    <app-type-public-step [formData]="wizardData().typePublic" [isReadonly]=" mode === 'view'"
                        [availableServicesOptions]="availableServicesOptions"
                        [functionalTypeOptions]="functionalTypeOptions"
                        (dataChange)="updateWizardData('typePublic', $event)">
                    </app-type-public-step>
                    }
                    @case (3) {
                    <app-multimedia-step [data]="wizardData().multimedia" [isReadonly]=" mode === 'view'"
                        (dataChange)="updateWizardData('multimedia', $event)">
                    </app-multimedia-step>
                    }
                    @case (4) {
                    <app-benefits-step [data]="wizardData().benefits" [isReadonly]=" mode === 'view'"
                        [faIconsOptions]="faIconsOptions" (dataChange)="updateWizardData('benefits', $event)">
                    </app-benefits-step>
                    }
                    @case (5) {
                    <app-pricing-step [data]="wizardData().pricing" [isReadonly]=" mode === 'view'"
                        [financialParameter]="financialParameter" [periodUnitOptions]="periodUnitOptions"
                        (dataChange)="updateWizardData('pricing', $event)">
                    </app-pricing-step>
                    }
                    @case (6) {
                    <app-capacities-step [data]="wizardData().capacities" [isReadonly]=" mode === 'view'"
                        [functionalType]="wizardData().typePublic.functionalTypeId"
                        (dataChange)="updateWizardData('capacities', $event)">
                    </app-capacities-step>
                    }
                    @case (7) {
                    @if(mode !== 'view') {
                    <app-review-publish-step [wizardData]="wizardData()" [isReadonly]="false"
                    [confirmationChecked]="confirmationChecked()"
                        (confirmationEvent)="confirmationChecked.set($event)" (navigateTo)="step.set($event)">
                    </app-review-publish-step>
                    }
                    }
                    }
                </div>
            </div>


            <div class="modal-footer">
                <!-- Navegación en modo VIEW -->
                @if(mode === 'view') {
                <button class="btn btn-light" [disabled]="step() === 1" (click)="prev()">
                    <i class="fa-solid fa-arrow-left"></i> Anterior
                </button>

                @if(step() < totalSteps) { <button class="btn btn-primary" (click)="next()">
                    Siguiente <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    }
                    @else {
                    <button type="button" class="btn btn-secondary" (click)="closeModal()">
                        <i class="fa-solid fa-xmark"></i> Cerrar
                    </button>
                    }
                    }
                    <!-- Navegación en modo CREATE/EDIT -->
                    @else {
                    <button class="btn btn-light" [disabled]="step() === 1 || loadingSvc.loading() || isSavingDraft()"
                        (click)="prev()">
                        <i class="fa-solid fa-arrow-left"></i> Anterior
                    </button>

                    @if(step() < totalSteps && step() !==6) { <button class="btn btn-primary"
                        [disabled]="loadingSvc.loading() || isSavingDraft()" (click)="next()">
                        Siguiente <i class="fa-solid fa-arrow-right"></i>
                        </button>
                        }
                        @else if(step() < totalSteps && step()===6) { <button class="btn btn-primary"
                            [disabled]="loadingSvc.loading() || isSavingDraft()" (click)="next()">
                            Revisar & Publicar ✓
                            </button>
                            }
                            @else {
                            <button type="button" class="btn btn-outline" (click)="saveDraft()">
                                @if(isSavingDraft()) {
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                                Guardando borrador...
                                } @else {
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                                    <polyline points="17,21 17,13 7,13 7,21" />
                                    <polyline points="7,3 7,8 15,8" />
                                </svg>
                                Guardar borrador
                                }
                            </button>

                            <button type="button" class="btn btn-success"
                                [disabled]="!confirmationChecked() || isSavingDraft() || loadingSvc.loading()"
                                (click)="submitPublish()">
                                @if(loadingSvc.loading()) {
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                                Publicando...
                                } @else {
                                Finalizar y Publicar
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path d="M20 6L9 17l-5-5" />
                                </svg>
                                }
                            </button>
                            }
                            }
            </div>
        </div>
    </div>
</div>